import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";

export default {
  getCompanyCompetitionList() {
    return apiService.get(endpoints.competition.companyCompetition);
  },

  getMapCompetitionList({ businessAddressId, competitionIds, keywordId }) {
    return apiService.get(
      `${endpoints.competition.mapCompetitionList}?business_address=${businessAddressId}&keyword=${keywordId}&business_address_competition=${competitionIds}`
    );
  },

  getCompetitionWebsites(companyId) {
    return apiService.get(
      `${endpoints.competition.default}${companyId}/website-competition/`
    );
  },

  postCompetitionWebsite(companyId, data) {
    return apiService.post(
      `${endpoints.competition.default}${companyId}/website-competition/`,
      data
    );
  },

  getSuggestedWebsites(companyId) {
    return apiService.get(
      `${endpoints.competition.default}${companyId}/suggested-website-competition/`
    );
  },

  deleteCompetitionWebsite(companyId, competitionWebsiteId) {
    return apiService.delete(
      `${endpoints.competition.default}${companyId}/website-competition/${competitionWebsiteId}/`
    );
  },

  getAvgCompetitionMapSearchResult(
    { businessAddress, competitionAddresses, keyword },
    { from, to }
  ) {
    return apiService.get(
      `${endpoints.avgMapSearchResult}?address=${businessAddress}&competition_addresses=${competitionAddresses}&keyword=${keyword}&searched_at__gte=${from}&searched_at__lte=${to}`
    );
  }
};
